import { render, staticRenderFns } from "./AreYouSureComment.vue?vue&type=template&id=00816210&scoped=true"
import script from "./AreYouSureComment.vue?vue&type=script&lang=js"
export * from "./AreYouSureComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00816210",
  null
  
)

export default component.exports